module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.73f0a88b.woff2";